module.exports = __webpack_public_path__ + "d664201f/img/send-icon.3cfb6275.svg";